/**
 * Create an object representing data for React Dropdown options
 * We only need to supply value and text. The key value will be same as value
 * to reduce chance of typo or mismatch between value and key
 *
 * @param value The value of item
 * @param text The text representing the value of this item
 * @returns {{text: *, value: *, key: *}}
 */
export const createDropdownItemByValueAndText = (value, text) => ({
  key: value,
  value,
  text,
});
